import React, { useState } from 'react';
import AnimatedIcon from '../components/AnimatedIcon';
import { useAuth } from '../context/AuthContext';
import { changePassword } from '../services/api';

/** Первый вход: пока общий пароль не заменён на свой, дальше среда не пускает. */
function ChangePasswordPage() {
  const { user, refresh, signOut } = useAuth();
  const [first, setFirst] = useState('');
  const [second, setSecond] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!first || !second) return;
    setBusy(true);
    setError(null);
    try {
      await changePassword(first, second);
      await refresh();
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сменить пароль.');
      setBusy(false);
    }
  };

  const field = {
    width: '100%', padding: '10px 12px', fontSize: 14, marginBottom: 12,
    border: '2px solid var(--mipt-border)', borderRadius: 8, outline: 'none',
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--mipt-bg)' }}>
      <form onSubmit={handleSubmit} style={{ width: 400, maxWidth: '92vw', background: 'white', padding: 32,
        borderRadius: 12, boxShadow: 'var(--mipt-shadow)', border: '1px solid var(--mipt-border)' }}>
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <AnimatedIcon name="planet" size={72} />
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: '8px 0 2px' }}>Придумайте свой пароль</h1>
          <div style={{ fontSize: 13, color: 'var(--mipt-text-secondary)', lineHeight: 1.5 }}>
            {user?.full_name ? `${user.full_name}, вы` : 'Вы'} вошли с общим паролем, который выдан всем
            при регистрации. Замените его, и среда откроется.
          </div>
        </div>

        <input type="password" value={first} onChange={(e) => setFirst(e.target.value)}
          placeholder="Новый пароль" autoComplete="new-password" style={field} />
        <input type="password" value={second} onChange={(e) => setSecond(e.target.value)}
          placeholder="Ещё раз" autoComplete="new-password" style={field} />

        {error && (
          <div style={{ fontSize: 13, color: 'var(--mipt-error)', marginBottom: 10, lineHeight: 1.5 }}>{error}</div>
        )}

        <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={busy}>
          {busy ? 'Меняем…' : 'Сменить пароль'}
        </button>

        <div style={{ marginTop: 12, fontSize: 12, color: 'var(--mipt-text-secondary)', textAlign: 'center' }}>
          Не меньше восьми символов, не только цифры, не из словаря частых паролей.
        </div>
        <div style={{ marginTop: 10, textAlign: 'center' }}>
          <button type="button" className="btn btn-ghost btn-sm" onClick={signOut}>Выйти</button>
        </div>
      </form>
    </div>
  );
}

export default ChangePasswordPage;
